// extracted by mini-css-extract-plugin
module.exports = {"cards":"ventures_cards__rXVhm","portfolio":"ventures_portfolio__Z2svc","ventureLogoWrapper":"ventures_ventureLogoWrapper__m0Bvw"};